var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full"},[_c('BaseForm',{ref:"form",staticClass:"flex flex-col",on:{"submit":_vm.submitForm}},[(_vm.newVal.productId == '')?_c('NewProductLine',{staticClass:"w-full",attrs:{"priceLevel":"online","edit":true,"products":[]},on:{"addProduct":_vm.addProduct}}):_c('div',[_c('p',[_vm._v("NKR code: "+_vm._s(_vm.newVal.nkrCode))]),_c('p',[_vm._v("Product ID: "+_vm._s(_vm.newVal.productId))]),_c('p',[_vm._v("Line: "+_vm._s(_vm.newVal.line))]),_c('button',{staticClass:"text-red-500",on:{"click":_vm.changeProduct}},[_vm._v(" Change product ")])]),_c('BaseTextField',{attrs:{"label":"Quantity per kit","type":"number","step":"1","required":""},model:{value:(_vm.newVal.quantity),callback:function ($$v) {_vm.$set(_vm.newVal, "quantity", $$v)},expression:"newVal.quantity"}}),_c('BaseSelectField',{attrs:{"options":[
        {
          code: 'discount',
          name: 'Discount',
          comment: 'Reducing price from online'
        },
        {
          code: 'none',
          name: 'No discount',
          comment: 'No discount applied'
        },
        { code: 'fixed', name: 'Fixed', comment: 'Final price' }
      ],"label":"Price type","required":""},model:{value:(_vm.newVal.priceType),callback:function ($$v) {_vm.$set(_vm.newVal, "priceType", $$v)},expression:"newVal.priceType"}}),_c('BaseSelectField',{attrs:{"options":[
        {
          code: 'na',
          name: 'na',
          comment: 'No applicable'
        },
        {
          code: 'percentage',
          name: 'Percentage',
          comment: 'Percentage to discount from price'
        },
        {
          code: 'fixed',
          name: 'Fixed amount',
          comment: 'Reduce fixed amount'
        }
      ],"label":"Discount type","required":""},model:{value:(_vm.newVal.productDiscountType),callback:function ($$v) {_vm.$set(_vm.newVal, "productDiscountType", $$v)},expression:"newVal.productDiscountType"}}),_c('BaseTextField',{attrs:{"label":"Discount value, or fixed price","type":"number","step":"0.01"},model:{value:(_vm.newVal.productDiscountValue),callback:function ($$v) {_vm.$set(_vm.newVal, "productDiscountValue", $$v)},expression:"newVal.productDiscountValue"}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }